import Home from "./[tenant]/home";

const Index = () => <Home />;

export default Index;
